import { Zigbee2MQTTUtils } from '../../../utils/zigbeeUtils';

export const sortByAccessAndType = (a, b) => {
  // features that we can actuate upon come first
  if (Zigbee2MQTTUtils.hasSet(a.access) !== Zigbee2MQTTUtils.hasSet(b.access))
    return Zigbee2MQTTUtils.hasSet(a.access) ? -1 : 1;

  // then sort by feature type (binary, numeric, etc)
  return sortByControlType(a, b);
};

const sortByControlType = (a, b) => {
  return a.type < b.type ? -1 : 1;
};
